module.exports = __webpack_public_path__ + "img/bonus.50180d9f.png";